import { Stack } from '@mui/material';

import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton';
import { translate } from '@/ui/i18n';

export function EditProjectFormButtons({
  submitButtonText = translate('Form.save'),
  isEditingProject,
}: {
  submitButtonText?: string;
  isEditingProject: boolean;
}) {
  return (
    <Stack
      display={'flex'}
      direction={'row'}
      justifyContent={'end'}
      sx={{ mt: 4 }}
    >
      <FSPrimaryButton type="submit" disabled={isEditingProject}>
        {submitButtonText}
      </FSPrimaryButton>
    </Stack>
  );
}
